import { differenceInCalendarDays } from 'date-fns';

import { Feature, FeatureTrial } from './types';

export type TrialFilter = 'all' | 'permanent' | 'temporary';

export const getUsedTrialFeatures = (
  featureTrials: ReadonlyArray<FeatureTrial> = [],
  now: Date,
): Feature[] =>
  featureTrials
    .filter(
      trial =>
        trial.trialEndDate !== undefined && differenceInCalendarDays(trial.trialEndDate, now) < 0,
    )
    .map(trial => trial.feature);

export function getActiveTrialFeatures(
  featureTrials: FeatureTrial[],
  filter: TrialFilter,
): Feature[] {
  if (!featureTrials.length) {
    return [];
  }

  const now = new Date();

  return featureTrials
    .filter(trial => {
      if (filter === 'permanent') {
        return !trial.trialEndDate;
      }
      if (filter === 'temporary') {
        return !!trial.trialEndDate;
      }
      return true;
    })
    .filter(trial => {
      if (!trial.trialEndDate) {
        return true;
      }
      return differenceInCalendarDays(trial.trialEndDate, now) >= 0;
    })
    .map(trial => trial.feature);
}
